/**
 * GraphQL queries and mutations for onboarding flow
 */

// Queries
export const SHOULD_SHOW_ONBOARDING = `
  query ShouldShowOnboarding {
    shouldShowOnboarding
  }
`;

export const MY_ONBOARDING_PROGRESS = `
  query MyOnboardingProgress {
    myOnboardingProgress {
      id
      currentStep
      completedSteps
      skippedSteps
      status
      completionPercent
      steps {
        stepKey
        displayName
        isRequired
        isSkippable
        isCompleted
        isSkipped
        sortOrder
      }
    }
  }
`;

// Mutations
export const START_ONBOARDING = `
  mutation StartOnboarding {
    startOnboarding {
      id
      currentStep
      completedSteps
      skippedSteps
      status
      completionPercent
      steps {
        stepKey
        displayName
        isRequired
        isSkippable
        isCompleted
        isSkipped
        sortOrder
      }
    }
  }
`;

export const COMPLETE_WELCOME_STEP = `
  mutation CompleteWelcomeStep {
    completeWelcomeStep {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_COMPANY_STEP = `
  mutation CompleteCompanyStep($input: CompanyStepInput!) {
    completeCompanyStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_STRATEGIC_CONTEXT_STEP = `
  mutation CompleteStrategicContextStep($input: StrategicContextInput!) {
    completeStrategicContextStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

// Merged "Context" step (onboarding trim 9→5).
export const COMPLETE_CONTEXT_STEP = `
  mutation CompleteContextStep($input: ContextStepInput!) {
    completeContextStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_TECHNOLOGY_STEP = `
  mutation CompleteTechnologyStep($input: TechnologyStepInput!) {
    completeTechnologyStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_AI_READINESS_STEP = `
  mutation CompleteAIReadinessStep($input: AIReadinessInput!) {
    completeAIReadinessStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_PROVIDER_STEP = `
  mutation CompleteProvidersStep {
    completeProvidersStep {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_TEAM_STEP = `
  mutation CompleteTeamStep($input: TeamStepInput!) {
    completeTeamStep(input: $input) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_FIRST_VALUE_STEP = `
  mutation CompleteFirstValueStep($choice: String!) {
    completeFirstValueStep(choice: $choice) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const COMPLETE_COMPLETE_STEP = `
  mutation CompleteCompleteStep {
    completeCompleteStep {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const SKIP_ONBOARDING_STEP = `
  mutation SkipOnboardingStep($stepKey: String!) {
    skipOnboardingStep(stepKey: $stepKey) {
      success
      message
      nextStep
      progress {
        id
        currentStep
        completedSteps
        skippedSteps
        status
        completionPercent
        steps {
          stepKey
          displayName
          isRequired
          isSkippable
          isCompleted
          isSkipped
          sortOrder
        }
      }
    }
  }
`;

export const DISMISS_ONBOARDING = `
  mutation DismissOnboarding {
    dismissOnboarding
  }
`;
